import React, {Component} from 'react';
import { translate } from 'react-admin';
import {configAPI} from '../config'
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';

class IncomingCalls extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.timer = setInterval(()=> this.getItems(), 3000);
    }
    componentWillUnmount() {
        clearInterval(this.timer);
        this.timer = null;
    }
    
    getItems() {
        const {push} = this.props;
        const ReqGetCalls = new Request(configAPI.api.prod+'GetIncomingCalls?token='+sessionStorage.B.encodeDecode());
        fetch(ReqGetCalls)
            .then(response => { return response.json();})
            .then(calls => {
                if (calls.responseStatus==='OK') {
                    if (calls.calls.length === 0) {
                        sessionStorage.setItem('incomingCalls', '[{"id":0, "duration":0}]');
                    }
                    else sessionStorage.setItem('incomingCalls', JSON.stringify(calls.calls));
                    this.setState({incomingCalls: calls.calls.length});
                }
                else {
                    push('/login');
                    sessionStorage.clear();
                }
        })
    }

    render() {
        return <span>{this.state.incomingCalls}</span>
    }

}
export default connect(null, {
    push: pushAction,
})(translate(IncomingCalls));